import { parsePhoneNumberWithError } from 'libphonenumber-js';
import { validateCharacters } from '../helper/validation';

const defaultCountryCode = 'SE';

export function validatePhoneNumber(phoneNumber?: string | null): boolean {
  try {
    return phoneNumber
      ? !!parsePhoneNumberWithError(phoneNumber, defaultCountryCode) && validateCharacters(phoneNumber)
      : false;
  } catch {
    return false;
  }
}

export function parseAndFormatPhoneNumber(phoneNumber: string): string {
  try {
    return parsePhoneNumberWithError(phoneNumber, defaultCountryCode).formatInternational().replaceAll(' ', '');
  } catch {
    return '';
  }
}
